const LOCALHOST_HOSTNAMES = Object.freeze({
    "localhost": true,
    "127.0.0.1": true,
    "::1": true,
    "0.0.0.0": true,
    "host.docker.internal": true
});

const normalizeLocalHostname = function(hostname){
    return typeof hostname === "string" ? hostname.trim().toLowerCase().replace(/^\[|\]$/g, "") : "";
};

const isPrivateIpv4Hostname = function(hostname){
    const normalizedHostname = normalizeLocalHostname(hostname);
    if(!/^\d{1,3}(\.\d{1,3}){3}$/.test(normalizedHostname)){
        return false;
    }
    const parts = normalizedHostname.split(".").map(function(part){
        return Number(part);
    });
    if(parts.some(function(part){
        return !Number.isInteger(part) || part < 0 || part > 255;
    })){
        return false;
    }
    return parts[0] === 10 ||
        (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) ||
        (parts[0] === 192 && parts[1] === 168) ||
        (parts[0] === 169 && parts[1] === 254);
};

const formatLocalHostnameForUrl = function(hostname){
    const normalizedHostname = normalizeLocalHostname(hostname);
    if(!normalizedHostname){
        return "localhost";
    }
    return normalizedHostname.indexOf(":") !== -1 ? "[" + normalizedHostname + "]" : normalizedHostname;
};

const isLocalhostHostname = function(hostname){
    const normalizedHostname = normalizeLocalHostname(hostname);
    return !!(normalizedHostname && (
        LOCALHOST_HOSTNAMES[normalizedHostname] ||
        normalizedHostname.endsWith(".localhost") ||
        isPrivateIpv4Hostname(normalizedHostname)
    ));
};

const getDefaultLocalApiBaseUrl = function(port){
    const resolvedPort = port || 8889;
    const hostname = (typeof window !== "undefined" && window.location && window.location.hostname) ?
        window.location.hostname : "localhost";
    return "http://" + formatLocalHostnameForUrl(hostname) + ":" + resolvedPort;
};

export {
    LOCALHOST_HOSTNAMES,
    normalizeLocalHostname,
    isPrivateIpv4Hostname,
    formatLocalHostnameForUrl,
    isLocalhostHostname,
    getDefaultLocalApiBaseUrl
};

export default {
    LOCALHOST_HOSTNAMES: LOCALHOST_HOSTNAMES,
    normalizeLocalHostname: normalizeLocalHostname,
    isPrivateIpv4Hostname: isPrivateIpv4Hostname,
    formatLocalHostnameForUrl: formatLocalHostnameForUrl,
    isLocalhostHostname: isLocalhostHostname,
    getDefaultLocalApiBaseUrl: getDefaultLocalApiBaseUrl
};
